<template>
  <v-dialog
    v-model="dialog_details"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="darkblue">
        <!-- <v-btn icon dark @click="closeDialogDetails">
			<v-icon>close</v-icon>
			</v-btn> -->
        <v-toolbar-title class="white--text">
          <div>
            {{
              this.filters && this.filters.power_plant
                ? this.filters.power_plant.name
                : ""
            }}
          </div>
          <span>{{
            this.filters && this.filters.competence
              ? this.filters.competence
              : "" | formatComp
          }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- <span>L: {{loadingBillings}}</span> -->
          <v-btn dark flat @click="closeDialogDetails">Fechar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container wrap fluid v-if="loadingBillings">
        <div class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </v-container>
      <v-container wrap fluid v-else>
        <template>
          <v-data-table
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loadingBillings"
            loading-text="Loading... Please wait"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            item-key="id"
            :rows-per-page-items="rowsPerPageItems"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há unidades consumidoras cadastradas"
          >
            <template v-slot:progress v-if="loadingBillings">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </template>
            <template v-slot:no-data>
              <v-progress-linear
                v-if="loadingBillings"
                color="blue"
                :indeterminate="loadingBillings"
              ></v-progress-linear>
              <v-alert :value="true" color="error" icon="warning" v-else>
                Erro: Não existem unidades consumidoras para essa planta
              </v-alert>
            </template>
            <!-- / -->
            <template v-slot:items="props" v-if="!loadingBillings">
              <td :class="props.item.status | statusClass">
                <div>
                  <v-tooltip
                    bottom
                    :color="props.item.status | formatUCStatusColor"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        :color="props.item.status | formatUCStatusColor"
                        left
                        v-on="on"
                      >
                        {{ props.item.status | formatUCStatusIcon }}
                      </v-icon>
                      {{ props.item.name }}
                    </template>
                    <span class="white--text">
                      {{ props.item.status | formatUCStatus }}
                      {{
                        props.item.status === "canceling"
                          ? " até " + props.item.billing_competence_end + ""
                          : ""
                      }}
                      {{
                        props.item.status === "canceled"
                          ? " em " + props.item.billing_competence_end + ""
                          : ""
                      }}
                    </span>
                  </v-tooltip>
                </div>
              </td>
              <td
                class="text-xs-right ${props.item.status === 'inactivated'?'red--text':'green--text'}"
              >
                {{ props.item.id }}
              </td>
              <td class="text-xs-right">
                {{ props.item.percentage | formatCurrency }}%
              </td>
              <td>{{ props.item.billing_competence_end | formatComp }}</td>
              <td
                class="text-xs-right"
                v-if="props.item.billing && props.item.billing.total"
              >
                R$ {{ props.item.billing.total | formatCurrency }}
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td
                class="text-xs-right"
                v-if="props.item.billing && props.item.billing.balance"
              >
                R$ {{ props.item.billing.balance | formatCurrency }}
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td
                class="text-xs-right"
                v-if="props.item.billing && props.item.billing.discount"
              >
                R$ {{ props.item.billing.discount | formatCurrency }}
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td
                class="text-xs-right green--text"
                v-if="
                  props.item.billing &&
                  (props.item.billing.status === 'paid' ||
                    props.item.billing.status === 'success')
                "
              >
                {{
                  props.item.billing && props.item.billing.transaction
                    ? props.item.billing.transaction.paid_at ||
                      props.item.billing.transaction.date_updated
                    : "-" | formatarDate
                }}
              </td>
              <td class="text-xs-right" v-else>
                <div
                  v-if="
                    props.item.billing &&
                    props.item.billing.transaction &&
                    props.item.billing.payment_service === 'pagarme'
                  "
                >
                  {{
                    props.item.billing.transaction.boleto_expiration_date
                      | formatarDate
                  }}
                </div>
                <div
                  v-if="
                    props.item.billing &&
                    props.item.billing.transaction &&
                    props.item.billing.payment_service === 'boletosimples'
                  "
                >
                  {{ props.item.billing.transaction.expire_at | formatarDate }}
                </div>
              </td>
              <td
                class="text-xs-right"
                v-if="
                  props.item.billing &&
                  (props.item.billing.status === 'paid' ||
                    props.item.billing.status === 'success')
                "
              >
                <div
                  v-if="
                    props.item.billing &&
                    props.item.billing.transaction &&
                    props.item.billing.payment_service === 'pagarme'
                  "
                >
                  {{
                    props.item.billing.transaction.paid_amount
                      | formatPaidPagarme
                  }}
                </div>
                <div
                  v-if="
                    props.item.billing &&
                    props.item.billing.transaction &&
                    props.item.billing.payment_service === 'boletosimples'
                  "
                >
                  {{
                    props.item.billing.transaction.paid_amount
                      | formatPaidBoletoSimples
                  }}
                </div>
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td class="text-xs-right" v-if="props.item.billing">
                <div>
                  <v-tooltip
                    bottom
                    :color="
                      props.item.billing.status | formatStatusBillingColor
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="props.item.billing"
                        :color="
                          props.item.billing.status | formatStatusBillingColor
                        "
                        v-on="on"
                        @click.prevent="
                          gotoTransactionHistory(props.item.billing.id)
                        "
                      >
                        {{
                          props.item.billing
                            ? props.item.billing.status
                            : "-" | formatStatus
                        }}
                      </v-icon>
                    </template>
                    <span class="white--text">
                      {{ props.item.billing.status | formatTransactionStatus }}
                    </span>
                  </v-tooltip>
                </div>
              </td>
              <td class="text-xs-right" v-else>-</td>
            </template>
          </v-data-table>
        </template>
      </v-container>
    </v-card>
    <cpnDetalhesFatura v-if="dialog_details" />
  </v-dialog>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { eventBus } from "@/main";
import DetalhesFatura from "../faturaDetails/DetalhesFatura";
export default {
  components: {
    cpnDetalhesFatura: DetalhesFatura,
  },
  computed: {
    ...mapState("billing", [
      "dialog_details",
      "items",
      "itemsComplete",
      "filters",
      "loadingBillings",
      "pagination",
      "totalItems",
    ]),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage,
      );
    },
    pagination: {
      get: function () {
        return this.$store.getters.pagination;
      },
      set: function (value) {
        this.$store.commit("setPagination", value);
      },
    },
    // loadingBillings: {
    //   get: function () {
    //     return this.$store.getters.loadingBillings
    //   },
    //   set: function (value) {
    //     this.$store.commit('setLoadingBillings', value)
    //   }
    // },
  },
  created() {
    // console.log("created")
  },
  mounted() {
    // console.log("dialog_details", this.dialog_details)
  },
  data: () => ({
    // loading: false,
    dialog: false,
    loading_export: false,
    totalDesserts: 0,
    // totalItems: 100,
    // pagination: {},
    rowsPerPageItems: [5, 10, 25, 100],
    // pagination: {
    //   descending: true,
    //   // page: 1,
    //   rowsPerPage: 25, // -1 for All",
    //   // sortBy: string,
    //   // totalItems: number
    // },
    pagination_before: {},
    headers: [
      {
        text: "Nome",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "U.C.", value: "id" },
      { text: "% Usina", value: "percentage" },
      { text: "Inic. Fat.", value: "billing_competence_start" },
      { text: "Créditos (R$)", value: "total" },
      { text: "Saldo", value: "saldo" },
      { text: "Economia", value: "saldo" },
      { text: "Data Pgto/Venc", value: "paid_at" },
      { text: "Val. Pago", value: "paid_amount" },
      { text: "", value: "status" },
    ],
  }),
  watch: {
    pagination: {
      async handler() {
        // const { // sortBy, descending,
        // page, rowsPerPage } = this.pagination
        // console.log("pag: ", this)
        // this.totalItems = this.pagination.totalItems
        /* 
          Se selecionou página anterior
          Pega os dados direto do array itemsComplete
		*/

        if (this.dialog_details === true && this.filters) {
          this.filters.pagination = this.pagination;
          this.filters.pagination_before = this.pagination_before;
          await this.getBillings(this.filters);
          this.pagination_before = this.pagination;
        }
      },
      deep: true,
    },
    async dialog_details(val) {
      // console.log("dialog_details: ", val)
      if (
        val === true &&
        (!this.items || (this.items && this.items.length <= 0)) &&
        this.filters
      ) {
        this.filters.pagination = this.pagination;
        this.getBillings(this.filters);
        this.pagination_before = this.pagination;
      }
    },
  },
  filters: {
    formatComp(val) {
      if (!val || val === "") return "";
      if (val.length <= 6) {
        let mes = val.substring(0, 2);
        let ano = val.substring(2, 6);
        return mes + "/" + ano;
      } else {
        let mes = val.split("-")[1];
        let ano = val.split("-")[0];
        return mes + "/" + ano;
      }
    },
    statusClass(val) {
      if (!val || val === "") return "";
      else if (val === "cancelling") return "orange--text";
      else if (val === "canceled") return "red--text";
    },
    formatPaidBoletoSimples(val) {
      if (!val || val === "" || val === "-") return "-";
      else return "R$ " + Number(val).toString().replace(".", ",");
    },
    formatPaidPagarme(val) {
      if (!val || val === "" || val === "-") return "-";
      else return "R$ " + (Number(val) / 100).toString().replace(".", ",");
    },
  },
  methods: {
    ...mapActions("billing", ["DialogDetails", "getBillings"]),
    closeDialogDetails() {
      this.DialogDetails(false);
    },
    gotoTransactionHistory(transaction_id) {
      eventBus.$emit("billing_id", transaction_id);
      eventBus.$emit("right", true);
      // this.$router.replace(`/transaction/${transaction_id}`)
    },
  },
};
</script>
